import ImageButton from 'components/Theme/Elements/ImageButton';
import InstagramIcon from 'assets/discovery/insta-icon.png';

function InstagramIconButton() {
  return <ImageButton imageSrc={InstagramIcon} height={45} width={45} border />;
}

export default InstagramIconButton;
